import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Bug = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M6.094 9.416a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1m-12 0v4m0-4-2.75-1m2.75 5v2a6 6 0 0 0 12 0v-2m-12 0h-3m15 0v-4m0 4h3m-3-4 2.75-1m-14.75 9-2.75 1m14.75-1 2.75 1m-8.75-5v7m-4-13a4 4 0 0 1 8 0'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16.844 7.683h.95a.95.95 0 0 1 .872.574l1.416-.517a.95.95 0 0 1 1.217.57.954.954 0 0 1-.568 1.222l-1.987.725v2.193h1.9c.524 0 .95.427.95.953a.95.95 0 0 1-.95.954h-1.9v.953q-.001.615-.107 1.2l2.094.764c.493.18.747.727.568 1.222a.95.95 0 0 1-1.217.57l-2.05-.748a6.66 6.66 0 0 1-4.988 3.598v-8.513a.95.95 0 0 0-.95-.953.95.95 0 0 0-.95.953v8.513a6.66 6.66 0 0 1-4.988-3.598l-2.05.748a.95.95 0 0 1-1.218-.57.954.954 0 0 1 .569-1.222l2.094-.764q-.106-.585-.107-1.2v-.953h-1.9a.95.95 0 0 1-.95-.954c0-.526.425-.953.95-.953h1.9v-2.193l-1.987-.725a.954.954 0 0 1-.569-1.222.95.95 0 0 1 1.218-.57l1.416.517a.95.95 0 0 1 .872-.574h.95c0-2.633 2.126-4.767 4.75-4.767s4.75 2.134 4.75 4.767m-4.75-2.86a2.855 2.855 0 0 0-2.85 2.86h5.7c0-1.58-1.276-2.86-2.85-2.86'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
